import { Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import { ActionsCell } from '../../../Component/Common/Components/DataTable/ActionsCell';
import { DefaultCell } from '../../../Component/Common/Components/DataTable/DefaultCell';
import { ScorecardLicenseSummaryDataCore } from '../../../Component/Model/Dto/ScorecardLicense';
import { DateFormatter } from '../../../Component/Model/helpers';
import { ActionType, ILinkProps, TableColumn } from '../../../Component/Model/Table/Table';
import { useRecoilValue } from 'recoil';
import { userRolesState } from '../../../State/user.Atom';
import { getLinkTo } from '../../../Helpers/linkHelper';
import { ClientRole, SiteAdminRole, UserAdminRole, SubAdminRole } from '../../../Component/Common/Constants/UserRoles';
import { toast } from 'react-toastify';
import { isExpired } from '../../../Helpers/scorecardHelper';
import config from '../../../config';

interface ScorecardRows {
    id: string;
    name: ILinkProps;
    scorecardType: string;
    createdDate: string;
    fromDate: string;
    toDate: string;
    actions: ActionType[];
}

export interface ScorecardTable {
    columns: Array<TableColumn>;
    rows: Array<ScorecardRows>;
}


export function ScorecardTableMapper(results: ScorecardLicenseSummaryDataCore[] ,handleAssignUser : (id:string) => void, deleteScorecard : (id:string) => void): ScorecardTable {
    const userRoles = useRecoilValue(userRolesState);

    const handleLinkClick = (item: ScorecardLicenseSummaryDataCore) => {
        if (isExpired(item.expiryDate)) {
            toast.error('The scorecard license has expired. Please renew your license before you can edit');
        } 
        else if(userRoles.includes(SiteAdminRole) || userRoles.includes(UserAdminRole) || userRoles.includes(SubAdminRole)){
            window.location.href = (`${config.publicUrl}/#scorecard/${item.scorecardId}/groupDashboard`);
        }
        else if(userRoles.includes(ClientRole)){
            window.location.href = (`${config.publicUrl}/#general/${item.scorecardId}`);            
        }
    };
    const columns = [
        { Header: 'Name', accessor: 'name', id : "scorecardName", Cell: ({ value }: any) => <Typography variant="caption" fontWeight='regular' color="#007bff" component={Link} to={value.linkTo}>{value.itemName}</Typography> },
        { Header: 'Scorecard Type', accessor: 'scorecardType', id: "scorecardType", Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'Created Date', accessor: 'createdDate', Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'From Date', accessor: 'fromDate', id : "startDate", Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'To Date', accessor: 'toDate', id : "endDate", Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'Actions', accessor: 'actions', Cell: ({ value }: any) => <ActionsCell actions={value} />, disableSortBy: true }
    ];
    if (results.length > 0) {
        const rows = results.map((item: ScorecardLicenseSummaryDataCore, index: number) => ({
            id: item.scorecardId,
            name: {
                linkTo: getLinkTo(item, userRoles, true, false), itemName: (userRoles.includes(ClientRole) || userRoles.includes(SiteAdminRole) || userRoles.includes(UserAdminRole) || userRoles.includes(SubAdminRole)) ?
                    (
                        <div
                            style={{ cursor: "pointer" }}
                            onClick={() => handleLinkClick(item)}
                        >
                            {item.scorecardName}
                        </div>
                    ) : item.scorecardName
            },
            scorecardType: item.scorecardType,
            createdDate: DateFormatter(item.createdDate.toString()),
            fromDate: DateFormatter(item.startDate.toString()),
            toDate: DateFormatter(item.endDate.toString()),
            totalPoints: item.totalPoints,
            adjustedLevel: item.adjustedLevel,
            actions: [
                {
                    key: index.toString(),
                    label: 'Assign Users',
                    action: () => {
                        handleAssignUser(item.scorecardId);
                    },
                    icon: {
                        color: 'primary',
                        name: 'person_add'
                    }
                },
                {
                    key: index.toString(),
                    label: 'Delete',
                    action: () => {
                        deleteScorecard(item.scorecardId);
                    },
                    icon: {
                        color: 'error',
                        name: 'delete'
                    }
                },
            ]

        }));
        return { columns: columns, rows: rows };
    }
    else{
        return { columns: columns, rows: [] };
    }
}

